import React from 'react';
import * as _ from 'lodash';
import moment from 'moment';
import { default as SystemNotice } from '../../src/components/modals/common/SystemNotice';
import { NotificationService } from '../services/Notification';
import SessionStorageService from '../services/utilities/SessionStorageService';
import { messageUtility } from '../utilities/messageUtility';
import Loader from '../components/Loader';
moment.locale('ja');

/**
 * @description システムからの通知モーダルコンポーネント
 */
export default class FieldsSystemNotices extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      notices: [],
      modalVisible: {
        detail: false,
      },
      detail: {},
    };

    this.setNotifications = this.setNotifications.bind(this);
    this.openNociteModal = this.openNociteModal.bind(this);
    this.closeNoticeModal = this.closeNoticeModal.bind(this);
    this.readAndOpenNextNocite = this.readAndOpenNextNocite.bind(this);
    this.onClickedCloseButton = this.onClickedCloseButton.bind(this);
    this.openNextNotices = this.openNextNotices.bind(this);

    this.isProxyLogin = SessionStorageService.isProxyLogin();
  }

  componentWillMount() {
    this.setNotifications();
  }

  setNotifications() {
    if (this.state.loaded) {
      return true;
    }
    const pageParam = {
      order: 'display_start_date_desc',
      only_unread: 1,
      limit: 30,
    };

    // 呼び出し中であることを表示
    Loader.start();

    const params = _.assign(pageParam);
    NotificationService.systemList(params)
      .then(response => {
        if (response.result) {
          const getNotices = response.data.entities.notices;
          if (!_.isEmpty(getNotices)) {
            this.setState({
              notices: getNotices,
              total: response.data.total,
              loaded: true,
            });
            return getNotices;
          } else {
            // close modal
            this.closeNoticeModal();
            return [];
          }
        } else {
          return [];
        }
      })
      .then(notices => {
        if (notices.length > 0) {
          this.openNociteModal(notices[0]);
        }
        Loader.done();
      });
  }

  openNociteModal = notice => {
    if (notice) {
      notice.created_at = moment(notice.created_at).format('YYYY/MM/DD HH:mm');
      this.setState({
        modalVisible: {
          detail: true,
        },
        detail: notice,
      });
    }
  };

  closeNoticeModal() {
    this.setState({
      modalVisible: {
        detail: false,
      },
      detail: {},
      notices: [],
    });
  }

  // システム通知モーダルのクローズボタンを押したときの挙動
  onClickedCloseButton = () => {
    if (this.isProxyLogin === true) {
      this.openNextNotices(); // 代理ログインの場合
    } else {
      this.readAndOpenNextNocite();
    }
  };

  // 代理ログインのユーザーの場合、モーダルのクローズボタンを押したときの処理
  openNextNotices = () => {
    this.setState({ loaded: false });

    const currentNotice = this.state.detail;
    let notices = _.cloneDeep(this.state.notices);

    // モーダルで開かれた通知に対し、既読フラグを記録
    notices = this.setLocalReadMark(notices, currentNotice.id);

    // 次の通知を探す
    const [hasNextNotice, nextNotice] = this.getNextNotices(
      notices,
      currentNotice.id
    );

    if (hasNextNotice) {
      this.setState({
        notices,
        loaded: true,
      });
      this.openNociteModal(nextNotice);
    } else {
      this.terminateNoticeModal();
    }
  };

  // モーダルで開かれた通知に対し、既読フラグ(notice.readOnModal)を記録
  setLocalReadMark(notices, currentNoticeId) {
    _.some(notices, notice => {
      if (notice.id === currentNoticeId && !notice.readOnModal) {
        notice.readOnModal = true;
        return true;
      }
      return false;
    });
    return notices;
  }

  // 次の通知があるかどうか, ある場合は次の通知を返す
  getNextNotices(notices, currentNoticeId) {
    let nextNotice;
    const hasNextNotice = _.some(notices, notice => {
      // 更新した通知は表示対象外
      if (notice.id !== currentNoticeId && !notice.readOnModal) {
        nextNotice = notice;
        return true;
      }
      return false;
    });
    return [hasNextNotice, nextNotice];
  }

  // 通常ログインのユーザーの場合、モーダルのクローズボタンを押したときの処理
  readAndOpenNextNocite = () => {
    const noticeId = this.state.detail.id;
    // 通知を既読にするAPI
    NotificationService.read(noticeId).then(response => {
      if (response.result) {
        this.openNextNotices();
      }
    });
  };

  // モーダル通知の終了処理
  terminateNoticeModal() {
    if (this.isProxyLogin === true) {
      this.closeNoticeModal(); // モーダルを閉じる
    } else {
      this.setNotifications(); // 次の通知をAPIから取りに行く
    }
  }

  render() {
    return (
      <SystemNotice
        visible={this.state.modalVisible.detail}
        title={this.state.detail.title}
        date={this.state.detail.display_start_date}
        message={this.state.detail.content}
        buttonText={messageUtility.getMessage('I-000-017')}
        onClose={this.onClickedCloseButton}
        loaded={this.state.loaded}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/FieldsSystemNotices.jsx